export const NoResultsFoundNotification = function () {
    return (
        <div className='alert-message notification error'>
            <span>No projects in this area, try another location or removing a filter</span>
        </div>
    );
};
